import {useState, useEffect} from "react";
import {useUserLogin} from "./UserLogin";

export function useUserInfo() {
    const [, , userObj] = useUserLogin();
    const [info, setInfo] = useState(null);

    useEffect(() => {
        if (!info) {
            setInfo(userObj);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [info, userObj]);
    return info;
}
